<footer [class]="`app-footer-${color}`">
  <p>&copy; 2026 Sygma. Tous droits réservés.</p>
</footer>